// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation EmailStripePaymentLinkMutation($input: EmailStripePaymentLinkInput!) {
    emailStripePaymentLink(input: $input) {
      success
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
